import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
import axios from "axios";

import HeroBanner from "../components/sections/HeroBanner";
import Bestseller from "../components/sections/Bestseller";
import NewIn from "../components/sections/NewIn";
// import ShopByOccasion from "../components/sections/ShopByOccasion";
import AboutStory from "../components/sections/AboutStory";
// import ImageGrid from "../components/sections/ImageGrid";
// import FeaturedArticles from "../components/sections/FeaturedArticles";
// import Testimonials from "../components/sections/Testimonials";
import InstagramSection from "../components/InstagramSection";
// import Newsletter from "../components/sections/Newsletter";

const API = process.env.REACT_APP_BACKEND_URL;

// Dummy product data (replace with real images from your project)
const dummyBestSellers = [
  { _id: 1, name: "Nami Exquisite Embroidery Short", price: 3390, image: "/images/best1.jpg" },
  { _id: 2, name: "Singerie Applique Shirt", price: 3690, image: "/images/best2.jpg" },
  { _id: 3, name: "Gua Embroidered Short", price: 2890, image: "/images/best5.jpg" },
  { _id: 4, name: "Samsoni Shirt", price: 1990, image: "/images/best3.JPG" },
  { _id: 5, name: "Everyday Embroidery Shirt", price: 2490, image: "/images/product4.jpeg" },
];

const dummyNewIn = [
  { _id: 6, name: "Anouk Embroidery Shirt", price: 3090, image: "/images/newin1.jpg" },
  { _id: 7, name: "Mawan Embroidery Shirt", price: 2490, image: "/images/newin2.jpg" },
  { _id: 8, name: "Zini Embroidery Shirt", price: 3990, image: "/images/newin3.jpg" },
  { _id: 9, name: "Katsu Embroidery Shirt", price: 1990, image: "/images/newin4.jpg" },
  { _id: 10, name: "Aya's Embroidery Shirts", price: 3090, image: "/images/home3.jpeg" },
];

const Home = () => {
  // const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!API) {
      console.error("Backend URL not defined");
      return;
    }
    axios
      .get(`${API}/api/products`)
      .then((res) => {
        console.log("Products:", res.data);
        setProducts(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  const bestSellers = products.length > 0 ? products.slice(0, 5) : dummyBestSellers;
  const newIn = products.length > 0 ? products.slice(5, 10) : dummyNewIn;

  return (
    <>
      <HeroBanner />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-24">
        {/* <Bestseller products={dummyBestSellers} />
        <NewIn products={dummyNewIn} /> */}
        <Bestseller products={bestSellers} />
<NewIn products={newIn} />
        {/* <ShopByOccasion /> */}
        <AboutStory />
        {/* <ImageGrid /> */}
        {/* <FeaturedArticles /> */}
        {/* <Testimonials /> */}
        <InstagramSection />
        {/* <Newsletter /> */}
      </main>
    </>
  );
};

export default Home;